import { application } from "../application"

import AquiferUiChartController from "./library/chart_controller"
import ImageGalleryController from "./library/image_gallery_controller"
import ImageModalController from "./library/image_modal_controller"
import BadgeEmoticonsController from "./library/badge_emoticons_controller"
import BadgeFeedbackStarsController from "./library/badge_feedback_stars_controller"
import CaseCardController from "./library/case_card_controller"
import CaseCardQuizDetailsController from "./library/case_card_quiz_details_controller"
import CaseCardCoursesUsingCaseModalController from "./library/case_card_courses_using_case_modal_controller"
import CaseCardLearningObjectivesModalController from "./library/case_card_learning_objectives_modal_controller"
import CaseCardModMapModalController from "./library/case_card_mod_map_modal_controller"
import CaseCardSynopsisModalController from "./library/case_card_synopsis_modal_controller"
import TeachingPointModalController from "./library/teaching_point_modal_controller"
import AssignedOutOfPlatformWorkflowController from "./library/assigned_out_of_platform_workflow_controller"
import CreateListModalController from "./library/create_list_modal_controller"
import RemoveTodoConfirmationModalController from "./library/remove_todo_confirmation_modal_controller"
import CheckboxIndeterminateController from "./library/checkbox_indeterminate_controller"
import ChoiceAccessibleController from "./library/choice_accessible_controller"
import CodeHighlightController from "./library/code_highlight_controller"
import DarkModeController from "./library/dark_mode_controller"
import DatePickerController from "./library/date_picker_controller"
import DropdownController from "./library/dropdown_controller"
import DropdownMenuController from "./library/dropdown_menu_controller"
import NestedDropdownController from "./library/nested_dropdown_controller"
import FilterPanelController from "./library/filter_panel_controller"
import FlyoutController from "./library/flyout_controller"
import ModalController from "./library/modal_controller"
import OtherFieldToggleController from "./library/user_profile/other_field_toggle_controller"
import PaginationRowsController from "./library/pagination_rows_controller"
import EmailContinueController from "./library/email_continue_controller"
import PasswordSignInController from "./library/password_sign_in_controller"
import OtpSignInController from "./library/otp_sign_in_controller"
import MfaBackupCodesCopyController from "./library/mfa_backup_codes_copy_controller"
import PasswordVisibilityController from "./library/password_visibility_controller"
import SignUpController from "./library/sign_up_controller"
import IndsubCheckoutModalController from "./library/indsub_checkout_modal_controller"
import QuizGeneratorFormController from "./library/quiz_generator/quiz_generator_form_controller"
import SharedSuccessOptoutController from "./library/shared_success_optout_controller"
import SharedSuccessPaymentController from "./library/shared_success_payment_controller"
import RailsuiTooltipController from "./library/railsui_tooltip_controller"
import QuizResultsQuizSelectorController from "./library/quiz_results_quiz_selector_controller"
import QuizResultsRecommendedCasesScrollController from "./library/quiz_results_recommended_cases_scroll_controller"
import QuizResultsTodoModalController from "./library/quiz_results_todo_modal_controller"
import QuizResultsTodoFormController from "./library/quiz_results_todo_form_controller"
import QuizResultsQuestionCardController from "./library/quiz_results_question_card_controller"
import PracticeSmartQuestionsModalController from "./library/practice_smart_questions_modal_controller"
import QuizPlayer__QuizChromeController from "./library/quiz_player/quiz_chrome_controller"
import QuizPlayer__QuizMcqController from "./library/quiz_player/quiz_mcq_controller"
import QuizPlayer__QuizModeController from "./library/quiz_player/quiz_mode_controller"
import QuizPlayer__QuizOfflineController from "./library/quiz_player/quiz_offline_controller"
import QuizPlayer__QuizPrefetchController from "./library/quiz_player/quiz_prefetch_controller"
import QuizPlayer__CalibrateOrientationController from "./library/quiz_player/calibrate_orientation_controller"
import QuizPlayer__CalibrateHonorCodeController from "./library/quiz_player/calibrate_honor_code_controller"
import QuizPlayer__CalibrateFormController from "./library/quiz_player/calibrate_form_controller"
import QuizPlayer__CalibrateOfflineController from "./library/quiz_player/calibrate_offline_controller"
import QuizPlayer__CalibrateTimerController from "./library/quiz_player/calibrate_timer_controller"
import RailsuiTabs from "./library/railsui_tabs_controller"
import StudentHomeDashboardTabController from "./library/student_home_dashboard_tab_controller"
import StudentHomeCourseUpdateController from "./library/student_home_course_update_controller"
import StudentHomeOrientationController from "./library/student_home_orientation_controller"
import ContentLogMobileCardController from "./library/content_log_mobile_card_controller"
import ContentLogResponsiveController from "./library/content_log_responsive_controller"
import TableSortController from "./library/table_sort_controller"
import TableScrollRegionController from "./library/table_scroll_region_controller"
import TodoDateController from "./library/todo_date_controller"
import TodoItemController from "./library/todo_item_controller"
import TodoNotesController from "./library/todo_notes_controller"
import RailsuiNavController from "./demo/railsui_nav_controller"
import ReportDashboardFilterAssessmentModalController from "./library/report_dashboard/filter_assessment_modal_controller"
import ReportDashboardPageController from "./library/report_dashboard/page_controller"
import ReportDashboardSelectModalController from "./library/report_dashboard/select_modal_controller"
import SidebarController from "./library/sidebar_controller"
import StickyAlertController from "./library/sticky_alert_controller"
import SearchInputController from "./library/search_input_controller"
import {
  RailsuiCombobox,
  RailsuiCountUp,
  RailsuiDateRangePicker,
  RailsuiRange,
  RailsuiReadMore,
  RailsuiSelectAll,
  RailsuiToggle,
} from "railsui-stimulus"
import RailsuiToast from "./library/toast_controller"
import DesignSystemScrollportController from "./library/design_system_scrollport_controller"
import EducatorHomePage__CourseMonitoringTableFrameController from "./library/educator_home_page/course_monitoring/course_monitoring_table_frame_controller"
import EducatorHomePage__TabsController from "./library/educator_home_page/tabs_controller"
import EducatorHomePage__CourseMonitoringExpandRowController from "./library/educator_home_page/course_monitoring/course_monitoring_expand_row_controller"
import EducatorHomePage__CourseMonitoringResponsiveRowController from "./library/educator_home_page/course_monitoring/course_monitoring_responsive_row_controller"
import StudentsModalController from "./library/students_modal_controller"
import EducatorHomePage__FiltersRuntimeController from "./library/educator_home_page/filters_runtime_controller"
import EducatorHomePage__StudentActivityLogExportController from "./library/educator_home_page/individual_student_performance/student_activity_log_export_controller"
import EducatorHomePage__ContentUsageLogExportController from "./library/educator_home_page/school_usage/content_usage_log_export_controller"
import EducatorHomePage__TableFrameController from "./library/educator_home_page/table_frame_controller"
import EducatorHomePage__SkeletonWaitController from "./library/educator_home_page/skeleton_wait_controller"
import EducatorHomePage__LazyFrameController from "./library/educator_home_page/lazy_frame_controller"
import EducatorHomePage__AssessmentSummaryCardsRowController from "./library/educator_home_page/assessment_summary_cards_row_controller"
import EducatorHomePage__UsageTrendsOpenQuestionController from "./library/educator_home_page/school_usage/usage_trends_open_question_controller"
import EducatorHomePage__CalibrateCurricularActionItemsCardController from "./library/educator_home_page/assessment_data/calibrate_curricular_action_items_card_controller"
import EducatorHomePage__AiAssistantController from "./library/educator_home_page/ai_assistant_controller"
import EducatorHomePage__AiAssistantFeedbackController from "./library/educator_home_page/ai_assistant_feedback_controller"
import EducatorHomePage__AiAssistantHistoryController from "./library/educator_home_page/ai_assistant_history_controller"
import EducatorHomePage__PerformanceTrendsTableFrameController from "./library/educator_home_page/performance_trends_table_frame_controller"
import ContentPatientLibrary__ResponsiveFiltersController from "./library/content_patient_library/responsive_filters_controller"
import ContentPatientLibrary__ActiveFiltersController from "./library/content_patient_library/active_filters_controller"
import ContentPatientLibrary__DisciplinePillsController from "./library/content_patient_library/discipline_pills_controller"
import ContentPatientLibrary__SelectedItemsController from "./library/content_patient_library/selected_items_controller"
import ContentPatientLibrary__ResultsFocusController from "./library/content_patient_library/results_focus_controller"
import ContentPatientLibrary__SortController from "./library/content_patient_library/sort_controller"

application.register("aquifer-ui-chart", AquiferUiChartController)
application.register("aquifer-ui-code-highlight", CodeHighlightController)
application.register("aquifer-ui-flyout", FlyoutController)
application.register("aquifer-ui-pagination-rows", PaginationRowsController)
application.register("aquifer-ui-search-input", SearchInputController)
application.register("aquifer-ui-sidebar", SidebarController)
application.register("design-system-scrollport", DesignSystemScrollportController)
application.register("aquifer-ui-quiz-results-quiz-selector", QuizResultsQuizSelectorController)
application.register(
  "aquifer-ui-quiz-results-recommended-cases-scroll",
  QuizResultsRecommendedCasesScrollController
)
application.register("aquifer-ui-quiz-results-todo-modal", QuizResultsTodoModalController)
application.register("aquifer-ui-quiz-results-todo-form", QuizResultsTodoFormController)
application.register("aquifer-ui-quiz-results-question-card", QuizResultsQuestionCardController)
application.register(
  "aquifer-ui-practice-smart-questions-modal",
  PracticeSmartQuestionsModalController
)
application.register("quiz-player--quiz-chrome", QuizPlayer__QuizChromeController)
application.register("quiz-player--quiz-mcq", QuizPlayer__QuizMcqController)
application.register("quiz-player--quiz-mode", QuizPlayer__QuizModeController)
application.register("quiz-player--quiz-offline", QuizPlayer__QuizOfflineController)
application.register("quiz-player--quiz-prefetch", QuizPlayer__QuizPrefetchController)
application.register("quiz-player--calibrate-orientation", QuizPlayer__CalibrateOrientationController)
application.register("quiz-player--calibrate-honor-code", QuizPlayer__CalibrateHonorCodeController)
application.register("quiz-player--calibrate-form", QuizPlayer__CalibrateFormController)
application.register("quiz-player--calibrate-offline", QuizPlayer__CalibrateOfflineController)
application.register("quiz-player--calibrate-timer", QuizPlayer__CalibrateTimerController)
application.register("aquifer-ui-table-sort", TableSortController)
application.register("aquifer-ui-table-scroll-region", TableScrollRegionController)
application.register("todo-date", TodoDateController)
application.register("todo-item", TodoItemController)
application.register("todo-notes", TodoNotesController)
application.register("badge-emoticons", BadgeEmoticonsController)
application.register("badge-feedback-stars", BadgeFeedbackStarsController)
application.register("case-card", CaseCardController)
application.register("case-card-quiz-details", CaseCardQuizDetailsController)
application.register("case-card-courses-using-case-modal", CaseCardCoursesUsingCaseModalController)
application.register("case-card-learning-objectives-modal", CaseCardLearningObjectivesModalController)
application.register("case-card-mod-map-modal", CaseCardModMapModalController)
application.register("case-card-synopsis-modal", CaseCardSynopsisModalController)
application.register("teaching-point-modal", TeachingPointModalController)
application.register("assigned-out-of-platform-workflow", AssignedOutOfPlatformWorkflowController)
application.register("create-list-modal", CreateListModalController)
application.register("remove-todo-confirmation-modal", RemoveTodoConfirmationModalController)
application.register("checkbox-indeterminate", CheckboxIndeterminateController)
application.register("choice-accessible", ChoiceAccessibleController)
application.register("quiz-generator-form", QuizGeneratorFormController)
application.register("shared-success-optout", SharedSuccessOptoutController)
application.register("shared-success-payment", SharedSuccessPaymentController)
application.register("railsui-image-gallery", ImageGalleryController)
application.register("railsui-image-modal", ImageModalController)
application.register("railsui-combobox", RailsuiCombobox)
application.register("railsui-count-up", RailsuiCountUp)
application.register("railsui-dark-mode", DarkModeController)
application.register("railsui-date-picker", DatePickerController)
application.register("railsui-date-range-picker", RailsuiDateRangePicker)
application.register("railsui-dropdown", DropdownController)
application.register("railsui-dropdown-menu", DropdownMenuController)
application.register("aquifer-ui-nested-dropdown", NestedDropdownController)
application.register("railsui-filter-panel", FilterPanelController)
application.register("railsui-modal", ModalController)
application.register("railsui-nav", RailsuiNavController)
application.register("railsui-range", RailsuiRange)
application.register("railsui-read-more", RailsuiReadMore)
application.register("railsui-select-all", RailsuiSelectAll)
application.register("railsui-sticky-alert", StickyAlertController)
application.register("railsui-tabs", RailsuiTabs)
application.register("student-home-dashboard-tab", StudentHomeDashboardTabController)
application.register("student-home-course-update", StudentHomeCourseUpdateController)
application.register("student-home-orientation", StudentHomeOrientationController)
application.register("content-log-mobile-card", ContentLogMobileCardController)
application.register("content-log-responsive", ContentLogResponsiveController)
application.register("railsui-toast", RailsuiToast)
application.register("railsui-toggle", RailsuiToggle)
application.register("railsui-tooltip", RailsuiTooltipController)
application.register("report-dashboard-ds-page", ReportDashboardPageController)
application.register("report-dashboard-ds-filter-assessment", ReportDashboardFilterAssessmentModalController)
application.register("report-dashboard-ds-select-modal", ReportDashboardSelectModalController)
application.register("aquifer-ui-email-continue", EmailContinueController)
application.register("aquifer-ui-password-sign-in", PasswordSignInController)
application.register("aquifer-ui-otp-sign-in", OtpSignInController)
application.register("aquifer-ui-mfa-backup-codes-copy", MfaBackupCodesCopyController)
application.register("aquifer-ui-password-visibility", PasswordVisibilityController)
application.register("aquifer-ui-sign-up", SignUpController)
application.register("indsub-checkout-modal", IndsubCheckoutModalController)
application.register("other-field-toggle", OtherFieldToggleController)
application.register("educator-home-page--course-monitoring-table-frame", EducatorHomePage__CourseMonitoringTableFrameController)
application.register("educator-home-page--tabs", EducatorHomePage__TabsController)
application.register("educator-home-page--course-monitoring-expand-row", EducatorHomePage__CourseMonitoringExpandRowController)
application.register("educator-home-page--course-monitoring-responsive-row", EducatorHomePage__CourseMonitoringResponsiveRowController)
application.register("students-modal", StudentsModalController)
application.register("educator-home-page--filters-runtime", EducatorHomePage__FiltersRuntimeController)
application.register("educator-home-page--student-activity-log-export", EducatorHomePage__StudentActivityLogExportController)
application.register("educator-home-page--content-usage-log-export", EducatorHomePage__ContentUsageLogExportController)
application.register("educator-home-page--table-frame", EducatorHomePage__TableFrameController)
application.register("educator-home-page--skeleton-wait", EducatorHomePage__SkeletonWaitController)
application.register("educator-home-page--lazy-frame", EducatorHomePage__LazyFrameController)
application.register(
  "educator-home-page--assessment-summary-cards-row",
  EducatorHomePage__AssessmentSummaryCardsRowController
)
application.register("educator-home-page--usage-trends-open-question", EducatorHomePage__UsageTrendsOpenQuestionController)
application.register(
  "educator-home-page--calibrate-curricular-action-items-card",
  EducatorHomePage__CalibrateCurricularActionItemsCardController
)
application.register("educator-home-page--ai-assistant", EducatorHomePage__AiAssistantController)
application.register(
  "educator-home-page--ai-assistant-feedback",
  EducatorHomePage__AiAssistantFeedbackController
)
application.register(
  "educator-home-page--ai-assistant-history",
  EducatorHomePage__AiAssistantHistoryController
)
application.register(
  "educator-home-page--performance-trends-table-frame",
  EducatorHomePage__PerformanceTrendsTableFrameController
)
application.register("content-patient-library--responsive-filters", ContentPatientLibrary__ResponsiveFiltersController)
application.register("content-patient-library--active-filters", ContentPatientLibrary__ActiveFiltersController)
application.register("content-patient-library--discipline-pills", ContentPatientLibrary__DisciplinePillsController)
application.register("content-patient-library--selected-items", ContentPatientLibrary__SelectedItemsController)
application.register("content-patient-library--results-focus", ContentPatientLibrary__ResultsFocusController)
application.register("content-patient-library--sort", ContentPatientLibrary__SortController)
